

import * as ProgressPrimitive from "@radix-ui/react-progress";
import * as React from "react";

import { cn } from "@sunfish/lib/utils";

import { SunfishMark } from "./sunfish-mark";

const Progress = React.forwardRef<
  React.ElementRef<typeof ProgressPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof ProgressPrimitive.Root> & {
    marker?: boolean;
    indicatorStyle?: React.CSSProperties;
    // Opt-in only: default "all" preserves every existing caller's behavior.
    // "transform" is for callers whose indicator color can change out from under
    // them (e.g. tenant branding resolving after paint) and must never crossfade.
    indicatorTransition?: "all" | "transform";
  }
>(({ className, value, color, marker, indicatorStyle, indicatorTransition = "all", ...props }, ref) => (
  <ProgressPrimitive.Root
    ref={ref}
    className={cn(
      "relative h-2 w-full rounded-full bg-primary/20",
      marker ? "overflow-visible" : "overflow-hidden",
      className,
    )}
    {...props}
  >
    <div className={cn("h-full w-full", marker && "overflow-hidden rounded-full")}>
      <ProgressPrimitive.Indicator
        className={cn(
          "h-full w-full flex-1 bg-primary",
          indicatorTransition === "transform" ? "transition-transform" : "transition-all",
          color,
        )}
        style={{ transform: `translateX(-${100 - (value || 0)}%)`, ...indicatorStyle }}
      />
    </div>
    {marker && (
      <SunfishMark
        className="absolute top-1/2 h-[26px] w-[26px] -translate-x-1/2 -translate-y-1/2 text-blue-500 transition-all dark:text-foreground"
        style={{ left: `${value || 0}%` }}
      />
    )}
  </ProgressPrimitive.Root>
));
Progress.displayName = ProgressPrimitive.Root.displayName;

export { Progress };
